import React from 'react';
import SvgIcon from './SvgIcon';

const MultipleUsersFull = props => (
    <SvgIcon {...props}>
        <g id="1️⃣-Massive-Natural-Event" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="5---All-Widgets"
                transform="translate(-937.000000, -1410.000000)"
                fill="currentColor"
                fillRule="nonzero"
            >
                <g id="Group-30" transform="translate(678.000000, 1288.000000)">
                    <g id="Group-5" transform="translate(16.000000, 68.000000)">
                        <g id="multiple-19" transform="translate(243.000000, 54.000000)">
                            <path
                                d="M5.5,9 C7.32966667,9 8.70466667,9.461 9.53595238,9.8475 C10.425381,10.261 11,11.1425 11,12.0925 L11,12.0925 L11,14 L0,14 L0,12.0925 C0,11.1425 0.574619048,10.261 1.46404762,9.8475 C2.29533333,9.461 3.67033333,9 5.5,9 Z M11.5320267,8 C12.9092138,8 14.0067583,8.3065 14.6853646,8.564 C15.4843433,8.8665 16,9.5945 16,10.419 L16,10.419 L16,12 L11.2692048,12 L11.2692048,11.5925 C11.2692048,10.2895 10.5212135,9.018 9,8.3575 C9.65547796,8.167 10.5170083,8 11.5320267,8 Z M5,2 C6.65709091,2 8,3.231 8,4.75 C8,6.269 6.65709091,8 5,8 C3.34290909,8 2,6.269 2,4.75 C2,3.231 3.34290909,2 5,2 Z M11.5,2 C12.8805556,2 14,3.0075 14,4.25 C14,5.4925 12.8805556,7 11.5,7 C10.1194444,7 9,5.4925 9,4.25 C9,3.0075 10.1194444,2 11.5,2 Z"
                                id="Combined-Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

MultipleUsersFull.displayName = 'MultipleUsersFullIcon';

export default MultipleUsersFull;
